module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "fi-header"
  }, [_c('div', {
    staticClass: "hl"
  }), _vm._v(" "), _c('div', {
    staticClass: "hr"
  }, [_c('ul', {
    staticClass: "link clearfix"
  }, _vm._l((_vm.headerText), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'active': _vm.headerActive[index]
      },
      on: {
        "click": function($event) {
          return _vm.headerHandle(index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.name) + "\n                    ")])
  }), 0), _vm._v(" "), (!_vm.regBox.isUserShow) ? _c('div', {
    staticClass: "fun"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "btn login",
    on: {
      "click": _vm.loginHandle
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('li', {
    staticClass: "btn register",
    on: {
      "click": _vm.regHandle
    }
  }, [_vm._v("注册")])])]) : _vm._e(), _vm._v(" "), (_vm.regBox.isUserShow) ? _c('div', {
    staticClass: "login-box"
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.regBox.phone))]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": _vm.changeUserHandle
    }
  }, [_vm._v("切换账户")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")])])]) : _vm._e()])])]), _vm._v(" "), _c('reg-box', {
    attrs: {
      "reg-box": _vm.regBox
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ae48279"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/index.vue
// module id = 330
// module chunks = 1